export default {
    dependencies: ['$element', 'radio', 'trackingservice'],
    callable(element, radio, trackingService) {
        const CLICK_COUNTER = 'data-promoted-click-counter-id';
        const VIEW_COUNTER = 'data-promoted-view-counter-id';
        const CLICK_WEBSTAT_COUNTER = 'data-promoted-click-webstat-counter-id';
        const VIEW_WEBSTAT_COUNTER = 'data-promoted-view-webstat-counter-id';

        function addClickTracking() {
            const counterElements = element.querySelectorAll(
                `[${CLICK_COUNTER}]`
            );
            Array.from(counterElements).forEach(counterElement => {
                counterElement.addEventListener('click', event => {
                    const finnkode = event.currentTarget.getAttribute(
                        'data-finnkode'
                    );
                    const eventObject = {
                        ecType: 'AD',
                        ecCategory: event.currentTarget.getAttribute(
                            CLICK_COUNTER
                        ),
                        context: {
                            finnkode,
                        },
                    };

                    const webstatCounter = event.currentTarget.getAttribute(
                        CLICK_WEBSTAT_COUNTER
                    );
                    if (webstatCounter != null) {
                        eventObject.eventName = webstatCounter;
                    }
                    trackingService.trackLaterObj(eventObject);
                });
            });
        }

        function performCount() {
            const elems = document.querySelectorAll(`[${VIEW_COUNTER}]`);
            Array.from(elems).forEach(e => {
                trackingService.trackEventObject({
                    ecType: 'AD',
                    ecCategory: e.getAttribute(VIEW_COUNTER),
                    context: {
                        finnkode: e.id,
                    },
                });
            });
        }

        function performWebstatCount() {
            Array.from(
                document.querySelectorAll(`[${VIEW_WEBSTAT_COUNTER}]`)
            ).forEach(trackShownPromotedAd);
        }

        function trackShownPromotedAd(ele) {
            trackingService.deprecatedTrackEvent(
                ele.getAttribute(VIEW_WEBSTAT_COUNTER)
            );
        }

        function init() {
            addClickTracking();
            performCount();
            performWebstatCount();
            radio('filter-and-search-changed').subscribe(performCount);
            radio('filter-and-search-changed').subscribe(performWebstatCount);
            radio('filter-and-search-changed').subscribe(addClickTracking);
        }

        return init();
    },
};



// WEBPACK FOOTER //
// ./controllers/searchGalleryCount.js